
/* shwygame => 文件夹 => shwygame.com */
// const uniteData = {
//     name: '嘉兴微羽科技有限公司上海分公司',
//     address: '公司地址：上海市普陀区中江路879弄6号楼2012室',
//     mobile: '18267340811',
//     filing: '沪ICP备2022016672号-1',
// };
// const homeToastText = '来自微羽科技，助力企业发展';
// const logoName = "微羽网络";



/* weiyushfun => 文件夹 => weiyushfun.com */
// const uniteData = {
//     name: '嘉兴微羽科技有限公司上海分公司',
//     address: '公司地址：上海市普陀区中江路879弄6号楼2012室',
//     mobile: '18267340811',
//     filing: '沪ICP备2022016672号-2',
// };
// const homeToastText = '来自微羽科技，助力企业发展';
// const logoName = "微羽网络";



/* weizionline => 文件夹 => weizionline.com */
// const uniteData = {
//     name: '嘉兴微紫科技有限公司',
//     address: '公司地址：浙江省嘉兴市嘉善县罗星街道瑞力动漫生活广场3幢10楼1001-8室（住所申报）',
//     mobile: '18267340811',
//     filing: '浙ICP备2022023841号-2',
// };
// const homeToastText = '来自微紫科技，助力企业发展';
// const logoName = "微紫科技";



/* weizi123 => 文件夹 => weizi123.com  */
// const uniteData = {
//     name: '嘉兴微紫科技有限公司',
//     address: '公司地址：浙江省嘉兴市嘉善县罗星街道瑞力动漫生活广场3幢10楼1001-8室（住所申报）',
//     mobile: '18267340811',
//     filing: '浙ICP备2022023841号-1',
// };
// const homeToastText = '来自微紫科技，助力企业发展';
// const logoName = "微紫科技";


/* weiyou456 => 文件夹 => weiyou456.com  */
// const uniteData = {
//     name: '嘉兴微游科技有限公司',
//     address: '公司地址：浙江省嘉兴市嘉善县罗星街道瑞力动漫生活广场3幢10楼1001-7室（住所申报）',
//     mobile: '18267340811',
//     filing: '浙ICP备2022023588号-2',
// };
// const homeToastText = '来自微游科技，助力企业发展';
// const logoName = "微游科技";



/* weiyou123 => 文件夹 => weiyou123.com   */
const uniteData = {
    name: '嘉兴微游科技有限公司',
    address: '公司地址：浙江省嘉兴市嘉善县罗星街道瑞力动漫生活广场3幢10楼1001-7室（住所申报）',
    mobile: '18267340811',
    filing: '浙ICP备2022023588号-1',
};
const homeToastText = '来自微游科技，助力企业发展';
const logoName = "微游科技";





export {
    uniteData,
    homeToastText,
    logoName,
};